/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceSortField } from '../models/ResourceSortField';
import { SortOrder } from '../models/SortOrder';

/**
* List of sorting options. Sorting is applied in the order passed in the list. 
*/
export class SortResourceBy {
  'field': ResourceSortField;
  'order': SortOrder;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "field",
      "baseName": "field",
      "type": "ResourceSortField",
      "format": ""
    },
    {
      "name": "order",
      "baseName": "order",
      "type": "SortOrder",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SortResourceBy.attributeTypeMap;
  }

  public constructor() {
  }
}



